import React from "react";
import * as RadixAvatar from "@radix-ui/react-avatar";
import "./styles.css";
import { theme } from "assets/theme";
import { color } from "utils/helpers";

export function getInitials(name: string) {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("");
}

const getAvatarSize = (size: string) => {
  switch (size) {
    case "1":
      return "24px";
    case "2":
      return "34px";
    case "3":
      return "48px";
    case "4":
      return "58px";
    case "5":
      return "68px";
    default:
      return "48px";
  }
};
const getTextSize = (size: string) => {
  switch (size) {
    case "1":
      return "12px";
    case "2":
      return "16px";
    case "3":
      return "18px";
    case "4":
      return "20px";
    case "5":
      return "22px";
    default:
      return "18px";
  }
};

type Props = {
  src?: string;
  username: string;
  size?: "1" | "2" | "3" | "4" | "5";
  group?: boolean;
  borderColor?: string;
};
export const Avatar: React.FC<Props> = ({
  src,
  username,
  size,
  group,
  borderColor,
}) => {
  return (
    <RadixAvatar.Root
      className="AvatarRoot"
      style={{
        width: getAvatarSize(size || "3"),
        height: getAvatarSize(size || "3"),
        marginLeft: group ? "-12px" : "0px",
        border: group
          ? `2px solid ${borderColor || theme.colors.background.secondary}`
          : "none",
      }}
    >
      <RadixAvatar.Image className="AvatarImage" src={src} alt="Profile" />
      <RadixAvatar.Fallback
        className="AvatarFallback"
        delayMs={600}
        style={{
          fontSize: getTextSize(size || "3"),
          backgroundColor: color(username),
        }}
      >
        {getInitials(username)}
      </RadixAvatar.Fallback>
    </RadixAvatar.Root>
  );
};
